import { Text } from "@chakra-ui/react";

const FormLabel = ({ children }) => {
    return (
        <Text
            mb={2}
            fontSize="xs"
            fontWeight="700"
            color="gray.500"
            letterSpacing="1px"
            textTransform="uppercase"
        >
            {children}
        </Text>
    );
};

export default FormLabel;